import React from 'react';
import PropTypes from 'prop-types';
import { parse_align, parse_inline } from './noteFormatting';

const ALIGN_CLASS = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
  justify: 'text-justify'
};

// Renders a note written with the teacher app's formatting toolbar.
function FormattedNoteText({ text }) {
  const { align, body } = parse_align(text);
  return (
    <div className={`min-w-0 whitespace-pre-wrap break-words ${ALIGN_CLASS[align]}`}>
      {parse_inline(body).map((token, index) => {
        if (token.mark === 'bold') return <b key={index}>{token.text}</b>;
        if (token.mark === 'italic') return <i key={index}>{token.text}</i>;
        if (token.mark === 'underline') return <u key={index}>{token.text}</u>;
        // eslint-disable-next-line react/no-array-index-key
        return <React.Fragment key={index}>{token.text}</React.Fragment>;
      })}
    </div>
  );
}

FormattedNoteText.propTypes = {
  text: PropTypes.string
};

export default FormattedNoteText;
